export default __webpack_public_path__ + "static/media/dispersion-section.992ea302.svg";